export const devToolsEnabled = true;

export const environment = {
  production: false,
  environmentName: 'development',
  devToolsEnabled,
  backOfficeSessionTimeoutMs: 60 * 60 * 1000,
  useMockApi: false,
  useBackofficeCommerceMocks: false,
  apiBaseUrlFallbacks: ['http://localhost:8080/cc-backend-monolitic'],
};
